// extracted by css-extract-rspack-plugin
export default {"arrayDoubleDate":"Form__arrayDoubleDate--jrHmK","yesHaveJobcanHeader":"Form__yesHaveJobcanHeader--AGA8_","notHaveJobcanHeader":"Form__notHaveJobcanHeader--mps1D"};